import logoMobil from "../../assets/isologo.svg";
import arrowRightBlack from "../../assets/arrowRight-black.svg";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Drawer } from "flowbite-react";
import { Logout } from "../../utils/logout";
import { useAppContext } from "../../contexts/AppProvider";
import { Headphones, Heart, HelpCircle, MessageSquare, PencilLine, Shield, User } from "lucide-react";
import useMedia from "../../hooks/useMedia";
import { useQuery } from "@tanstack/react-query";
import { URL_API } from "../../config/default";
import { myHeaders } from "../../config/axios";

export default function Footer() {
  const isMobile = useMedia("(max-width: 768px)", false);
  const { me }: any = useAppContext();
  const navigation = useNavigate();
  const [canvaMenu, setCanvaMenu] = useState(false);

  // Fetch conversations count
  const { data: conversationsData } = useQuery({
    queryKey: ["conversations"],
    queryFn: () => {
      return fetch(`${URL_API}/chat/conversations`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => {
        if (!res.ok) throw new Error("Error fetching conversations");
        return res.json();
      });
    },
    enabled: !!me,
  });

  const activeConversationsCount =
    conversationsData?.data?.filter((conv: any) => conv.status === "active")
      .length || 0;

  // Fetch favorites count
  const { data: favoritesData } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => {
      return fetch(`${URL_API}/favorites`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => {
        if (!res.ok) throw new Error("Error fetching favorites");
        return res.json();
      });
    },
    enabled: !!me,
  });

  const favoritesCount = favoritesData?.data?.length || 0;

  const menu = [
    {
      title: "Configuración de la cuenta",
    },
    {
      name: "Informacion personal",
      icon: <User className="w-4 h-4" />,
      dropdown: false,
      link: "/informacion",
      divider: false,
    },
    /*
    {
      name: "Cuenta",
      icon: ajuste,
      dropdown: false,
      link: "/cuenta",
      divider: false,
    },
    */
    {
      divider: true,
      hidden: false,
    },
    {
      title: "Viajeros",
      hidden: false,
    },
    {
      name: "Favoritos",
      icon: <Heart className="w-4 h-4" />,
      dropdown: false,
      link: "/favoritos",
      divider: false,
      hidden: false,
      badge: favoritesCount,
    },
    {
      name: "Reservas",
      icon: <PencilLine className="w-4 h-4" />,
      dropdown: false,
      link: "/mis-reservas",
      divider: false,
      hidden: false,
    },
    {
      name: "Mensajes",
      icon: <MessageSquare className="w-4 h-4" />,
      dropdown: false,
      link: "/chat",
      divider: false,
      hidden: false,
      badge: activeConversationsCount,
    },
    {
      divider: true,
    },
    {
      title: "Ayuda",
    },
    {
      name: "Soporte Tecnico",
      icon: <HelpCircle className="w-4 h-4" />,
      dropdown: false,
      link: "/soporte-tecnico",
      divider: false,
    },
    {
      name: "Privacidad, Terminos y condiciones",
      icon: <Shield className="w-4 h-4" />,
      dropdown: false,
      link: "/privacidad-y-terminos-de-uso",
      divider: false,
      hidden: false,
    },
    {
      name: "Recursos de anfitrion",
      icon: <Headphones className="w-4 h-4" />,
      dropdown: false,
      link: "/recursos-anfitrion",
      divider: false,
    },
  ];



  useEffect(() => {
    if (canvaMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup por si el componente se desmonta
    return () => {
      document.body.style.overflow = '';
    };
  }, [canvaMenu]);

  if (isMobile) {
    return (
      <footer className="flex sticky bottom-0 left-0 w-full bg-gradient-left z-[2]">
        <div className="flex-auto w-[70px] text-center">
          <Link to="/">
            <div className="my-2">
              <div>
                <img
                  src={logoMobil}
                  alt={"Rumbo Punilla"}
                  className="m-auto"
                  width={"40px"}
                />
              </div>
            </div>
          </Link>
        </div>
        <div className="flex-auto w-[70px] text-center">
          {me ? (
            <Link
              to={`/favoritos`}
              className={`cursor-pointer hover:opacity-50 px-4 border-0 border-white block rounded-md ${me ? "" : "hidden"}`}
              style={{ fontSize: "12px" }}
            >
              <div className="my-2">
                <div>
                  <Heart className="text-white mx-auto" />
                </div>
                <div className="text-white font-bold text-xs">Favoritos</div>
              </div></Link>)
            : ""}
        </div>
        <div className="flex-auto w-[70px] text-center">
          <Link
            to={`/dashboard`}
            className={`cursor-pointer hover:opacity-50 px-4 border-0 border-white block rounded-md ${me ? "" : "hidden"}`}
            style={{ fontSize: "12px" }}
          >
            <div className="my-2">
              <div>
                <User className="text-white mx-auto" />
              </div>
              <div className="text-white font-bold text-xs">Anfitrión</div>
            </div>
          </Link>
        </div>
        {me ? (
          <div className="flex-auto w-[70px] text-center">
            <label>
              <div className="my-2">
                <div>
                  <User className="text-white mx-auto" />
                </div>
                <div className="text-white font-bold text-xs">Perfil</div>
              </div>
              <button
                className="hidden"
                type="button"
                onClick={() => setCanvaMenu(true)}
              ></button>
            </label>
          </div>
        ) : (
          <div className="flex-auto w-[70px] text-center">
            <Link to={'/login'} >
              <div className="my-2 text-center">
                <div className="text-center w-full">
                  <User className="text-white mx-auto" />
                </div>
                <div className="text-white font-bold text-xs">Iniciar sesión</div>
              </div>
            </Link>
          </div>
        )}


        {
          me ? (
            <Drawer
              className="w-full z-[9999] fixed overflow-hidden"
              open={canvaMenu}
              onClose={() => setCanvaMenu(false)}
            >
              <Drawer.Header title="MENU" titleIcon={() => <></>} />
              <Drawer.Items >
                <div className="font-bold text-primary mb-5 flex items-center">
                  <div className="text-primary font-bold text-xl bg-white border rounded-2xl w-[30px] h-[30px] items-center flex justify-center me-2"></div>
                  {`${me?.firstname} ${me?.lastname}`}
                </div>
                <div className="my-5">
                  {menu.map((m: any, index: any) => {
                    if (m.title) {
                      return (
                        <div
                          className={`font-bold text-black mb-5 text-start ${m.hidden ? "hidden" : ""
                            }`}
                          key={index}
                        >
                          {m.title}
                        </div>
                      );
                    }
                    if (m.divider) {
                      return (
                        <hr
                          className="mb-5"
                          style={{ background: "#0000" }}
                          key={index}
                        />
                      );
                    }
                    return (

                      <Link
                        className="flex justify-between items-center text-start font-normal mb-3"
                        to={m.link}
                      >
                        <span className="ms-1 flex items-center">
                          <span className="me-1">
                            {typeof m.icon == "string" ? (
                              <img src={m.icon} style={{ width: "20px" }} alt="" />
                            ) : (
                              m.icon
                            )}
                          </span>
                          {m.name}
                          {m.badge !== undefined && m.badge > 0 && (
                            <span className="ms-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
                              {m.badge}
                            </span>
                          )}
                        </span>
                        <img src={arrowRightBlack} alt="" />
                      </Link>
                    );
                  })}
                </div>
                <div className="w-full my-5">
                  <label
                    className="
                cursor-pointer
                w-full
                mt-3
                bg-transparent 
                hover:bg-black
                text-dark-700 
                font-semibold 
                hover:text-white 
                py-2 px-4 
                border 
                border-dark-500 
                hover:border-transparent 
                rounded
                block
                text-center"
                  >
                    Cerrar sesión
                    <button
                      className="hidden"
                      onClick={() => Logout(navigation)}
                    ></button>
                  </label>
                </div>
              </Drawer.Items>
            </Drawer>
          ) : ""
        }
      </footer>
    )
  }

  return (
    <footer className="flex bg-gradient-left bottom-0 left-0 w-full z-50">
      <div className="hidden  md:grid grid-cols-3 gap-4 md:w-[80%] mx-auto py-5">
        <div className="col-span-1 my-5">
          <ul className="list-none ">
            <li className="font-bold text-white">Ayuda</li>
            <li className="">
              <Link key={0} className="text-white" to={"/soporte-tecnico"}>
                Centro de ayuda
              </Link>
            </li>
            <li className="">
              <Link key={1} className="text-white" to={"/politicas-de-cancelacion"}>
                Opciones de cancelación
              </Link>
            </li>
            <li className="">
              <Link key={2} className="text-white" to={"/problemas-alojamiento"}>
                Problemas con mi alojamiento
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-span-1 my-5">
          <ul className="list-none ">
            <li className="font-bold text-white">Cómo ser anfitrión</li>
            <li className="">
              <Link className="text-white" to={"/recursos-anfitrion"}>
                Recursos para anfitrión
              </Link>
            </li>
            <li className="">
              <Link className="text-white" to={"/guia-optimizar-anuncio"}>
                Sé un anfitrión responsable
              </Link>
            </li>
            <li className="hidden">
              <Link className="text-white" to={"#"}>
                Foro
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-span-1 my-5">
          <ul className="list-none ">
            <li className="font-bold text-white">Rumbo Punilla</li>
            <li className="hidden">
              <Link className="text-white" to={"#"}>
                Noticias
              </Link>
            </li>
            <li className="hidden">
              <Link className="text-white" to={"#"}>
                Empleo
              </Link>
            </li>
            <li className="hidden">
              <Link className="text-white" to={"#"}>
                Estadias
              </Link>
            </li>
          </ul>
        </div>
        <div className="col-span-3">
          <hr className="w-full" style={{ border: "2px solid white" }} />
        </div>
        <div className="col-span-3 flex justify-between">
          <span className="text-white">
            2023 Rumbo Punilla - Privacidad -Términos
          </span>
          <div className="flex ">
            <Link className="text-white" to={"#"}>
              <img src="" alt="" />
            </Link>
            <Link className="text-white" to={"#"}>
              <img src="" alt="" />
            </Link>
            <Link className="text-white" to={"#"}>
              <img src="" alt="" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
